import React from 'react';
import { FaCogs, FaChartLine, FaHandshake, FaPlane, FaSuitcase, FaTruckMoving } from 'react-icons/fa';

function BespokeSolutions() {
  const bespokeServices = [
    {
      service: "Tailored Logistics Solutions",
      description: "Customized transport and logistics services designed to meet your unique business needs, ensuring efficiency and reliability.",
      icon: <FaCogs className="w-16 h-16 text-black" />,
    },
    {
      service: "Optimized Supply Chain Management",
      description: "Streamlined supply chain strategies to enhance productivity, reduce costs, and improve delivery performance.",
      icon: <FaChartLine className="w-16 h-16 text-black" />,
    },
    // {
    //   service: "Business Growth Strategies",
    //   description: "Innovative strategies to drive business growth, enhance customer engagement, and optimize operations.",
    //   icon: <FaChartLine className="w-16 h-16 text-black" />,
    // },
    {
      service: "Dedicated Client Support",
      description: "A personalized support system that prioritizes your needs and provides round-the-clock assistance.",
      icon: <FaHandshake className="w-16 h-16 text-black" />,
    },
  ];

  const courierServices = [
    "ADR & Dangerous Goods",
    "Arts & Antiques",
    "Aviation (AOG)",
    "Construction",
    "Engineering",
    "Exhibition & Events",
    "Furniture & Fabrics",
    "Jewellery",
    "Legal",
    "Oil & Gas",
    "Pharmaceutical",
    "Photography & Production",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/bespoke.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Bespoke Solutions</h1>
        </div>
      </div>

      {/* Bespoke Services Section */}
      <section id="bespoke-services" className="py-16 bg-white text-black">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
          {bespokeServices.map((service, index) => (
            <div key={index} className="flex flex-col gap-6 items-center text-center mt-6">
              <h3 className="text-xl  md:text-3xl font-thin mb-1">{service.service}</h3>
              <div className="mb-2 text-red-500">{service.icon}</div>
              <p className="text-zinc-400 max-w-sm text-lg font-thin ">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Bespoke Courier Service Section */}
      <section id="courier-service" className="lg:py-20 bg-white text-black">
  <div className="max-w-7xl mx-auto px-6 lg:px-8">
    <h2 className=" text-4xl lg:text-5xl font-thin text-center mb-10">Services</h2>
    <div className="text-center text-black space-y-6 mb-12 font-thin">
      <p className="leading-relaxed text-lg" >
        When it comes to time-sensitive deliveries, you need to be able to trust the courier company you're working with. Not only do they need to be reliable, but they also need to have a strategy in place that is tailored specifically for your business.
      </p>
      <p className="leading-relaxed text-lg">
        1UKLogistics is the answer. We offer bespoke solutions that are tailored around your specific needs, and we have developed logistics strategies for a wide variety of different sectors all over the UK
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-center">
      {courierServices.map((service, index) => (
        <div
          key={index}
          className="bg-gray-800 p-6 rounded-lg shadow-lg hover:scale-105 transition-transform"
        >
          <h3 className="text-lg font-thin text-white">{service}</h3>
        </div>
      ))}
    </div>

    <div className="text-center text-black mt-12">
      <p className="leading-relaxed text-lg font-thin">
        We have access to over 3000 drivers, which allows us to offer a collection time within 60 minutes from quote approval.
      </p>
    </div>
  </div>
</section>

      {/* Why Choose Us Section */}
      <section id="why-choose-us" className="md:p-20 bg-white text-black">
        <div className="flex justify-center">
          <div className="space-y-8 w-full max-w-5xl">
            <h2 className="text-2xl  md:text-4xl font-thin text-center mb-8">Why Choose Our Bespoke Solutions?</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="flex flex-col items-center text-center">
                <div className="bg-red-500 w-16 h-16 flex items-center justify-center rounded-full mb-4">
                  <FaPlane className="text-white text-2xl" />
                </div>
                <h3 className="text-lg font-thin mb-2">Expertise You Can Trust</h3>
                <p className="text-zinc-400 text-base  font-thin">
                  With years of experience, we deliver tailored solutions to meet your unique business needs.
                </p>
              </div>
              <div className="flex flex-col items-center text-center">
                <div className="bg-red-500 w-16 h-16 flex items-center justify-center rounded-full mb-4">
                  <FaSuitcase className="text-white text-2xl" />
                </div>
                <h3 className="text-xl font-thin mb-2">Comprehensive Services</h3>
                <p className="text-zinc-400 font-thin">
                  From custom solutions to time-critical deliveries, we ensure reliability every step of the way.
                </p>
              </div>
              <div className="flex flex-col items-center text-center">
                <div className="bg-red-500 w-16 h-16 flex items-center justify-center rounded-full mb-4">
                  <FaTruckMoving className="text-white text-2xl" />
                </div>
                <h3 className="text-xl font-thin mb-2">Unmatched Efficiency</h3>
                <p className="text-zinc-400 font-thin">
                  Our dedicated team and advanced technology ensure your requirements are met promptly and precisely.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BespokeSolutions;
